import component from './cards.vue'

export default component
